import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import * as React from 'react';

var Action = function Action() {
  var _useMenuBalanceContex = useMenuBalanceContext(),
      menu = _useMenuBalanceContex.menu,
      hide = _useMenuBalanceContex.hide;

  if (!menu.action) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-header"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    label: menu.action.label,
    route: menu.action.route,
    url: menu.action.url,
    className: "btn btn-primary btn-block",
    onClick: function onClick() {
      hide();
    },
    visible: menu.action.visible
  }));
};

export { Action };